import { ItemAttributes } from "../../../js/parsegenerated";

export const CONFIG_KEY = "OPENSERVICE_ITEMS_TABLE_COLUMNS";

export type ItemTableConfig = {
  order: number;
  show: boolean;
  attribute: keyof ItemAttributes;
};

const createConfig = (attribute: keyof ItemAttributes): ItemTableConfig => ({
  attribute,
  show: false,
  order: 0,
});

export const DEFAULT_CONFIG: ItemTableConfig[] = [
  "description",
  "sources",
  "category",
  "internalNumber",
  "orderNumber",
  "price",
  "stock",
  "storageLocation",
  "supplier",
].map(createConfig);
